import { render, staticRenderFns } from "./FreeModeAlertForConditionsUsed.vue?vue&type=template&id=2bb0d9aa&"
import script from "./FreeModeAlertForConditionsUsed.vue?vue&type=script&lang=ts&"
export * from "./FreeModeAlertForConditionsUsed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports